var _defs, _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew233({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.63,6.48H3.88V7.82H5.54v.47H3.88v1.85H3.3V6H5.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.55,8a3.48,3.48,0,0,1,0,.57,2.74,2.74,0,0,1-.15.51,2,2,0,0,1-.26.42,1.44,1.44,0,0,1-.4.33,2.1,2.1,0,0,1-.55.21,2.93,2.93,0,0,1-.7.08H6.56V6H7.63a1.89,1.89,0,0,1,1.44.5A2.12,2.12,0,0,1,9.55,8ZM9,8.06a3.1,3.1,0,0,0-.08-.74,1.26,1.26,0,0,0-.25-.49,1,1,0,0,0-.42-.27,1.8,1.8,0,0,0-.6-.09H7.13V9.65h.42Q9,9.65,9,8.06Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.07,6.48H11.85v3.66h-.57V6.48H10.05V6h3Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.5,
    y: 3.7,
    width: 15,
    height: 8.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew233);
export default __webpack_public_path__ + "static/media/Symbolpack_New_233.b171a84e9f43d3b05e9796ba6e12e661.svg";
export { ForwardRef as ReactComponent };